import { Link } from "react-router-dom";
import "../styles/AppBanner.css";

export default function AppBanner() {
  return (
    <div className="app-banner">
      <div className="app-marquee">
        {/* Set 1 */}
        <div className="app-content">
          <span className="app-badge">NEW RELEASES</span>
          <span>⚡ Explore Almond Android Apps:</span>
          <span className="app-tag-pill">📝 DocNo (Notes & Expenses)</span>
          <span className="app-tag-pill">🎨 Forge (Photo Studio)</span>
          <span className="app-tag-pill">🎬 Video Player</span>
          <span className="app-tag-pill">🎵 Music Player</span>
          <Link to="/apps" className="app-btn">
            Explore 4 Apps →
          </Link>
        </div>

        {/* Set 2 (for infinite loop) */}
        <div className="app-content" aria-hidden="true">
          <span className="app-badge">NEW RELEASES</span>
          <span>⚡ Explore Almond Android Apps:</span>
          <span className="app-tag-pill">📝 DocNo (Notes & Expenses)</span>
          <span className="app-tag-pill">🎨 Forge (Photo Studio)</span>
          <span className="app-tag-pill">🎬 Video Player</span>
          <span className="app-tag-pill">🎵 Music Player</span>
          <Link to="/apps" className="app-btn">
            Explore 4 Apps →
          </Link>
        </div>
      </div>
    </div>
  );
}